import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import AuthUtility from "../../util/AuthUtility";
import { onBrandList, onCategoryList } from "../../controller/CategoryController";
import { ProductSearch } from "../../dto/product/ProductSearch";
import { ProductListEntity } from "../../dto/product/ProductListEntity";
import { Col, Button, Row, Container, Card, Form, InputGroup, Table, Pagination, Badge } from 'react-bootstrap';
import SearchIcon from '@mui/icons-material/Search';
import InfoIcon from '@mui/icons-material/Info';
import Select from 'react-select';
import toast, { Toaster } from 'react-hot-toast';
import { CategoryEntity } from "../../dto/category/CategoryEntity";
import { BrandEntity } from "../../dto/brand/BrandEntity";
import { onProductSearch } from "../../controller/ProductController";
import { Page } from "../../dto/page/Page";
import { ProductEntity } from "../../dto/product/ProductEntity";
import { getProductCondition, getProductMeasureSource, getProductStatus } from "../../app/AppConst";

const ProductList = () => {
    const navigate = useNavigate();
    useEffect(() => {
        if (!AuthUtility.isUserLoggedIn()) {
            navigate("/login");
            window.location.reload();
        } else {
            categoryListGet(); // categories list get into select option
            brandListGet(); // brands list get into select option
        }
    }, []);

    const [products, setProducts] = useState<ProductListEntity>({
        page: undefined,
        data: []
    });
    const [categoryOptions, setCategoryOptions] = useState<Array<Object>>([]);
    const [brandOptions, setBrandOptions] = useState<Array<Object>>([]);

    const categoryListGet = async () => {
        const response = await onCategoryList();
        const cats: Array<CategoryEntity> = response.data.beans;
        const optionArray: Array<Object> = [];
        cats.map((item, index) => {
            var obj = {
                value: item.id + "",
                label: item.name
            }
            optionArray.push(obj);
        })
        setCategoryOptions(optionArray);
    }

    const brandListGet = async () => {
        const response = await onBrandList();
        const brands: Array<BrandEntity> = response.data.beans;
        const optionArray: Array<Object> = [];
        brands.map((item, index) => {
            var obj = {
                value: item.id + "",
                label: item.name
            }
            optionArray.push(obj);
        })
        setBrandOptions(optionArray);
    }

    const [search, setSearch] = useState<ProductSearch>({
        offset: -1,
        limit: 10
    });

    const categoryIdsHandler = (value: Object) => {
        var ids: Array<number> = Array.isArray(value) ? value.map(x => parseInt(x.value)) : [];
        setSearch({
            ...search,
            categoryIds: ids
        })
    }

    const brandIdsHandler = (value: Object) => {
        var ids: Array<number> = Array.isArray(value) ? value.map(x => parseInt(x.value)) : [];
        setSearch({
            ...search,
            brandIds: ids
        })
    }

    // ---- Search submit
    const searchSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        load(0); // reset to first page on new search
    };

    // ---- Pagination click
    const changePage = (page: number) => {
        if (!products.page) return;
        if (page < 0 || page >= products.page.totalPages) return;
        load(page);
    };

    const load = async (page: number = 0) => {
        const params: ProductSearch = {
            ...search,
            offset: page
        };

        const response = await onProductSearch(params);

        if (response.status !== 0) {
            toast.error("Бүтээгдэхүүн уншихад алдаа гарлаа");
            return;
        }

        const pageable = response.data;

        const pageInfo: Page = {
            limit: search.limit,
            totalElements: pageable.totalElements,
            totalPages: pageable.totalPages,
            offset: page
        };

        const beans: Array<ProductEntity> = pageable.beans;

        setProducts({
            page: pageInfo,
            data: beans
        });

        setSearch(prev => ({ ...prev, offset: page }));
    };

    return (
        <Container fluid>
            <div><Toaster position="top-right" reverseOrder={false}/></div>
            <h3><a onClick={() => navigate(-1)}><big>&#8592;</big></a>Бүтээгдэхүүн</h3>
            <Row className="d-flex justify-content-center align-items-center mb-3">
                <Col md={12} lg={12} xs={12}>
                    <Card>
                        <Card.Header>
                            <Form onSubmit={searchSubmit}>
                                <Row>
                                    <Col md={3}>
                                        <Form.Group className="mb-3" controlId="name">
                                            <Form.Label className="text-center">Title</Form.Label>
                                            <Form.Control size="sm"
                                                onChange={(event) => {
                                                    const value = event.target.value;
                                                    if (value !== "") {
                                                        setSearch({
                                                            ...search,
                                                            title: event.target.value
                                                        })
                                                    } else {
                                                        const { title, ...rest } = search;
                                                        setSearch(rest);
                                                    }
                                                }} />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-3" controlId="name">
                                            <Form.Label className="text-center">Category</Form.Label>
                                            <Select
                                            options={categoryOptions}
                                            onChange={categoryIdsHandler}
                                            isMulti={true}
                                            isClearable={true}
                                            isSearchable={true}
                                            isDisabled={false}
                                            isLoading={false}
                                            isRtl={false}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3}>
                                        <Form.Group className="mb-3" controlId="name">
                                            <Form.Label className="text-center">Brand</Form.Label>
                                            <Select
                                            options={brandOptions}
                                            onChange={brandIdsHandler}
                                            isMulti={true}
                                            isClearable={true}
                                            isSearchable={true}
                                            isDisabled={false}
                                            isLoading={false}
                                            isRtl={false}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={3}>
                                        <Form.Group className="mb-3" controlId="offSet">
                                            <Form.Label>Багцлах</Form.Label>
                                            <InputGroup className="mb-3">
                                                <Form.Select size="sm"
                                                    onChange={(event) => setSearch({
                                                        ...search,
                                                        limit: parseInt(event.target.value)
                                                    })}>
                                                    <option value="10">10</option>
                                                    <option value="25">25</option>
                                                    <option value="0">Бүгд</option>
                                                </Form.Select>
                                                <Button variant="primary" size="sm" type="submit">
                                                    <SearchIcon fontSize="small"/>
                                                </Button>
                                            </InputGroup>
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Header>
                        <Card.Body>
                            <Table hover>
                                <thead>
                                    <tr>
                                        <th>Created At</th>
                                        <th>Title</th>
                                        <th>Description</th>
                                        <th>Category</th>
                                        <th>Brand</th>
                                        <th>Condition</th>
                                        <th>Status</th>
                                        <th>Prev status</th>
                                        <th>Weight grams</th>
                                        <th>Length mm</th>
                                        <th>Width mm</th>
                                        <th>Height mm</th>
                                        <th>Measure source</th>
                                        <th><InfoIcon /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {products.data.length === 0 && (
                                        <tr>
                                            <td className="text-muted">
                                                Илэрц олдсонгүй
                                            </td>
                                        </tr>
                                    )}

                                    {
                                        products.data.map((data, idx) => {
                                            return (
                                                <tr key={idx}>
                                                    <td>{data.createdAt
                                                    ? new Date(data.createdAt).toLocaleString()
                                                    : "-"}</td>
                                                    <td>{data.title}</td>
                                                    <td>{data.description}</td>
                                                    <td>{data.categoryName}</td>
                                                    <td>{data.brandName}</td>
                                                    <td>
                                                        <Badge bg={getProductCondition(data.conditionCode)}>{data.conditionCode}</Badge>
                                                    </td>
                                                    <td>
                                                        <Badge bg={getProductStatus(data.status)}>{data.status}</Badge>
                                                    </td>
                                                    <td>
                                                        <Badge bg={getProductStatus(data.prevStatus)}>{data.prevStatus}</Badge>
                                                    </td>
                                                    <td>{data.estWeightGrams}</td>
                                                    <td>{data.estLengthMm}</td>
                                                    <td>{data.estWidthMm}</td>
                                                    <td>{data.estHeightMm}</td>
                                                    <td>
                                                        <Badge bg={getProductMeasureSource(data.estMeasureSource)}>{data.estMeasureSource}</Badge>
                                                    </td>
                                                    <td><a href={`/product/${data.id}`}><InfoIcon /></a></td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                </Col>  
            </Row>

            {products.page && products.page.totalPages > 1 && (() => {
                const page = products.page;   // now TypeScript knows it's NOT undefined

                return (
                    <Row>
                        <Col className="d-flex justify-content-start">
                            <Pagination>
                                <Pagination.First
                                    disabled={page.offset === 0}
                                    onClick={() => changePage(0)}
                                />

                                <Pagination.Prev
                                    disabled={page.offset === 0}
                                    onClick={() => changePage(page.offset - 1)}
                                />

                                {Array.from({ length: page.totalPages })
                                    .slice(
                                        Math.max(page.offset - 2, 0),
                                        Math.min(page.offset + 3, page.totalPages)
                                    )
                                    .map((_, idx) => {
                                        const pageNumber =
                                            Math.max(page.offset - 2, 0) + idx;

                                        return (
                                            <Pagination.Item
                                                key={pageNumber}
                                                active={pageNumber === page.offset}
                                                onClick={() => changePage(pageNumber)}
                                            >
                                                {pageNumber + 1}
                                            </Pagination.Item>
                                        );
                                    })}

                                <Pagination.Next
                                    disabled={page.offset + 1 >= page.totalPages}
                                    onClick={() => changePage(page.offset + 1)}
                                />

                                <Pagination.Last
                                    disabled={page.offset + 1 >= page.totalPages}
                                    onClick={() => changePage(page.totalPages - 1)}
                                />
                            </Pagination>
                        </Col>
                    </Row>
                );
            })()}
        </Container>
    )
}

export default ProductList;